<template>
  <v-container>
    <v-progress-circular
      indeterminate
      color="primary"
      v-if="!apiErrorMsg"
    ></v-progress-circular>

    <br />

    <v-alert v-if="apiErrorMsg" prominent type="error">
      <v-row align="center">
        <v-col class="grow">
          {{ apiErrorMsg }}
        </v-col>
        <v-col class="shrink">
          <v-btn @click="closeWindow()">Close Window</v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <span v-if="!apiErrorMsg">
      <b>
        Please do not close this window, generating XERO token... <br />
        This window will auto close after completed.
      </b>
    </span>
  </v-container>
</template>

<script>
import hrdcFunction from "@/objects/hrdcFunction";
import HrdcDataMain from "@/services/hrdc/objects/globalData";
import HrdcDataEvent from "@/services/hrdc_event/objects/globalData";
import { mapState } from "vuex";
import Api from "@/objects/api";
import moment from "moment";

export default {
  mixins: [hrdcFunction],
  data: () => ({
    apiXeroExchangeCode: new Api(),
    apiStoreXeroToken: new Api(),
    hrdcData: null,
    serviceKey: null,
    apiErrorMsg: null,
  }),
  computed: {
    ...mapState({
      devAuth: (state) => state.devAuth.data,
    }),
  },
  methods: {
    getRedirectUri() {
      // Must EXACTLY match the redirect_uri sent to Xero in the authorize step.
      return `${process.env.VUE_APP_URL}/en/developer/callback_xero`;
    },
    closeWindow() {
      window.close();
    },
  },
  async created() {
    // The target service rides in the OAuth `state` param: "hrdc" for the HRDC
    // module, or an event service key for HRDC Event.
    const svc = this.$route.query.state || "hrdc";
    this.serviceKey = svc;

    const serviceUrl = this.$service[svc];
    if (!serviceUrl) {
      this.apiErrorMsg = `Unknown service "${svc}". You can close this window now.`;
      return;
    }

    // Stage reference data: synchronous for hrdc, async (fetched) for events.
    this.hrdcData =
      svc === "hrdc" ? new HrdcDataMain() : new HrdcDataEvent(serviceUrl);
    await this.hrdcData.allStages;

    const devUuid =
      this.devAuth && this.devAuth.identity ? this.devAuth.identity.uuid : null;

    this.apiStoreXeroToken.setUrl(
      `${serviceUrl}/v1/en/console/xero/store-xero-token`
    );
    this.apiStoreXeroToken.setMethod("post");
    this.apiXeroExchangeCode.setUrl(
      `${serviceUrl}/v1/en/console/xero/exchange-code`
    );
    this.apiXeroExchangeCode.setMethod("post");

    // Xero client secret + token URL are applied server-side; the client only
    // sends the authorization code.
    this.apiXeroExchangeCode.setParams({
      grant_type: "authorization_code",
      code: this.$route.query.code,
      redirect_uri: this.getRedirectUri(),
    });

    this.apiXeroExchangeCode.setCallbackCompleted((response) => {
      try {
        if (!response || !response.status) {
          throw new Error("Invalid Response");
        }

        // Store refresh_token in db (settings-level token => applicationUuid "token").
        this.apiStoreXeroToken.setParams({
          valid_from: moment().format("YYYY-MM-DD"),
          valid_to: moment().add(58, "days").format("YYYY-MM-DD"),
          token_type: "refresh_token",
          token: response.data.refresh_token,
          userUuid: devUuid,
          applicationUuid: "token",
          subscriptionStageId:
            this.hrdcData.stagePriority.subscriptionDateScheduled,
        });
        this.apiStoreXeroToken.setCallbackCompleted((storeRes) => {
          try {
            if (!storeRes || !storeRes.status) {
              throw new Error("Failed to generate refresh token");
            }
            return window.close();
          } catch (err) {
            console.log(err);
            this.apiErrorMsg = err.message;
            return false;
          }
        });
        this.apiStoreXeroToken.fetch();
      } catch (err) {
        let errorMsg = err.message;
        if (err.response?.data?.error) {
          errorMsg = err.response.data.error;
        }

        this.apiErrorMsg = `
          XERO Error Message: ${errorMsg};
          You can close this window manually now.
        `;

        return false;
      }
    });
    this.apiXeroExchangeCode.fetch();
  },
};
</script>
